export const queueFetch = (queue) => {
    $.ajax({
        url: queueable.serverQueueHandlerUrl,
        type: 'POST',
        dataType: 'text',
        data: { q: JSON.stringify(queue), t: Date.now() },
        success: function () {},
        error: function (jqXHR, exception) {
            console.log('Error with task. Message: ' + exception + '.');

            queueable.clearAllKeysForEntity();
            queueable.showServerErrorPopup();
        },
    });
};
